export default __webpack_public_path__ + "static/media/home.34b46b23.svg";